





















































































































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";

interface FormSubmissionEntity {
    form_submission_id: number;
    site_id: number | null;
    form_key: string;
    name: string;
    email: string;
    phone: string;
    subject: string;
    message: string;
    extra_data: string | null;
    mail_sent: number | string;
    /** Gönderilemediyse hata metni (sunucu extra_data._mail_error'dan verir) */
    mail_error?: string | null;
    is_read: number | string;
    created_at: string;
}

@Component({
    components: {DeleteButton}
})
export default class FormKayitlari extends Vue {
    baseAction: string = "forms";
    items: Array<FormSubmissionEntity> | null = null;
    selected: FormSubmissionEntity | null = null;
    dialog: boolean = false;

    get extraFields() {
        if (!this.selected) {
            return [];
        }
        const parsed = this.parseExtra(this.selected);
        // "_" ile başlayan anahtarlar sistem bilgisi (ör. _mail_error); ziyaretçinin girdiği alan değil
        return Object.keys(parsed)
            .filter(key => key.charAt(0) !== "_")
            .map(key => ({key, value: parsed[key]}));
    }

    get failedCount(): number {
        return (this.items || []).filter(item => !this.mailSent(item)).length;
    }

    parseExtra(item: FormSubmissionEntity): any {
        if (!item.extra_data) {
            return {};
        }
        try {
            const parsed = JSON.parse(item.extra_data);
            return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
        } catch (e) {
            return {};
        }
    }

    mailSent(item: FormSubmissionEntity): boolean {
        return Number(item.mail_sent) === 1;
    }

    mailError(item: FormSubmissionEntity): string {
        const direct = item.mail_error === undefined || item.mail_error === null ? "" : String(item.mail_error).trim();
        if (direct !== "") {
            return direct;
        }
        const fromExtra = this.parseExtra(item)._mail_error;
        return fromExtra === undefined || fromExtra === null ? "" : String(fromExtra).trim();
    }

    async show(item: FormSubmissionEntity) {
        this.selected = item;
        this.dialog = true;
        // Okundu olarak işaretlemek için tek kayıt çağrısı
        try {
            await this.$http.get(this.baseAction + "/" + item.form_submission_id);
            item.is_read = 1;
        } catch (e) {
            // okundu işareti kritik değil
        }
    }

    async getItems() {
        let response = await this.$http.get(this.baseAction);
        this.items = response.data;
    }

    created() {
        this.getItems();
    }
}
